<template>
  <div class="sub_news-container">
    <module1 />
    <module2 />
  </div>
</template>

<script>
import module1 from "./module1.vue";
import module2 from "./module2.vue";

export default {
  name: "Sub_NewsPage",
  components: {
    module1,
    module2,
  },
};
</script>

<style scoped>
.sub_news-container {
  display: flex;
  flex-direction: column;
}
</style>